var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner-row input-dialog" },
    [
      _c(
        "el-form",
        {
          staticStyle: { width: "100%", height: "800px" },
          attrs: { "label-position": "right", "label-width": "120px" }
        },
        [
          _c(
            "el-row",
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "700px",
                  height: "200px",
                  "padding-bottom": "5px"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.titleGrid.gridOptions,
                  "column-defs": _vm.titleGrid.titleColumnDefs,
                  "row-data": _vm.titleGrid.rowData
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.titleGrid.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.InvoiceChannel"),
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { no: "invoiceChannel", disabled: !_vm.isEdit },
                      on: { change: _vm.invoiceChannelChange },
                      model: {
                        value: _vm.from.invoiceChannel,
                        callback: function($$v) {
                          _vm.$set(_vm.from, "invoiceChannel", $$v)
                        },
                        expression: "from.invoiceChannel"
                      }
                    },
                    _vm._l(_vm.SystemConstants.INVOICE_CHANNEL_STATUS, function(
                      item
                    ) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.chineseName, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.isNuoNuo
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "APPkey", required: "" } },
                        [
                          _c("el-input", {
                            staticClass: "input-color",
                            staticStyle: { width: "300px" },
                            attrs: { no: "appKey", disabled: !_vm.isEdit },
                            model: {
                              value: _vm.from.appKey,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "appKey", $$v)
                              },
                              expression: "from.appKey"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "APPSecret", required: "" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { no: "appSecret", disabled: !_vm.isEdit },
                            model: {
                              value: _vm.from.appSecret,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "appSecret", $$v)
                              },
                              expression: "from.appSecret"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Token", required: "" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { no: "token", disabled: !_vm.isEdit },
                            model: {
                              value: _vm.from.token,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "token", $$v)
                              },
                              expression: "from.token"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isBwjsy
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "APPId", required: "" } },
                        [
                          _c("el-input", {
                            staticClass: "input-color",
                            staticStyle: { width: "300px" },
                            attrs: { no: "APPId", disabled: !_vm.isEdit },
                            model: {
                              value: _vm.from.appKey,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "appKey", $$v)
                              },
                              expression: "from.appKey"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "APPSecret", required: "" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { no: "appSecret", disabled: !_vm.isEdit },
                            model: {
                              value: _vm.from.appSecret,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "appSecret", $$v)
                              },
                              expression: "from.appSecret"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isNuoNuo || _vm.isBwjsy
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Invoicer"),
                            required: ""
                          }
                        },
                        [
                          _c("cargo-ag-grid", {
                            style:
                              (_vm.isBwjsy ? "width:670px;" : "width:500px;") +
                              "height:200px;",
                            attrs: {
                              "show-side-bar": false,
                              "grid-options": _vm.invoiceGrid.gridOptions,
                              "column-defs": _vm.invoiceGridColumnDefs,
                              "row-data": _vm.finalInvoiceRowData
                            },
                            on: {
                              gridReady: function(params) {
                                return (_vm.invoiceGrid.gridApi = params.api)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.InvoicerConfig"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                no: "invoiceIssuer",
                                disabled: !_vm.isEdit
                              },
                              model: {
                                value: _vm.from.invoiceIssuer,
                                callback: function($$v) {
                                  _vm.$set(_vm.from, "invoiceIssuer", $$v)
                                },
                                expression: "from.invoiceIssuer"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: { no: "OnlyInvoicer", label: 0 }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.OnlyInvoicer"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                { attrs: { no: "AllInvoicer", label: 1 } },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.AllInvoicer")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_CustomFields") + "1" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { no: "customField1", disabled: !_vm.isEdit },
                    model: {
                      value: _vm.from.customField1,
                      callback: function($$v) {
                        _vm.$set(_vm.from, "customField1", $$v)
                      },
                      expression: "from.customField1"
                    }
                  }),
                  _vm.isNuoNuo
                    ? _c(
                        "el-tooltip",
                        {
                          staticStyle: { "padding-left": "7px" },
                          attrs: {
                            content: _vm.$t("CargoMsg.Cargo_NuoNuoTipOne"),
                            placement: "right-end"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: { cursor: "pointer", color: "orange" }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_CustomFields") + "2" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { no: "customField2", disabled: !_vm.isEdit },
                    model: {
                      value: _vm.from.customField2,
                      callback: function($$v) {
                        _vm.$set(_vm.from, "customField2", $$v)
                      },
                      expression: "from.customField2"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_CustomFields") + "3" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { no: "customField3", disabled: !_vm.isEdit },
                    model: {
                      value: _vm.from.customField3,
                      callback: function($$v) {
                        _vm.$set(_vm.from, "customField3", $$v)
                      },
                      expression: "from.customField3"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }